export default (arr1, arr2) => {
  return [
    ...arr2,
    ...arr1.filter(item => {
      return !arr2.find(item2 => item2.name === item.name);
    })
  ];
};
